export enum VisitEntityType {
	Trip = 1,
	Visit = 2,
	ChildVisit = 3,
}
